import { loadingAsyncState } from "widgets-for-react";
import { fetchEvents } from "../../../../Shared/backendApi/EventsApi";
export const initialTippedActivitiesBlockState = (props)=>{
    return {
        events: loadingAsyncState(fetchEvents({
            page: 1,
            pageSize: props.row_count,
            from: undefined,
            to: undefined,
            tags: [],
            regions: props.regions,
            locations: [],
            query: ""
        }))
    };
};
